<script setup>
import { computed } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});
</script>

<template>
  <BaseBubble class="p-2 pb-1.5 min-w-[240px]" data-bubble-name="audio">
    <AudioChip
      :attachment="attachment"
      class="text-[#000000] skip-context-menu"
    />
  </BaseBubble>
</template>
